var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFanOn = function SvgFanOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.06 116.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b819fd92-8fc9-409a-8ce9-41d1ebd1119d",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M84,79a13.15,13.15,0,1,1,9.31-22.45h0A13.15,13.15,0,0,1,84,79Zm0-19.88a6.73,6.73,0,1,0,4.77,2h0A6.71,6.71,0,0,0,84,59.11Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M74.44,66.2a3.23,3.23,0,0,1-2.16-.83L35.56,32.24a10.48,10.48,0,1,1,14.8-14.8L83.5,54.16A3.21,3.21,0,0,1,82,59.39a6.74,6.74,0,0,0-4.52,4.52,3.21,3.21,0,0,1-2.21,2.17A3.13,3.13,0,0,1,74.44,66.2ZM42.58,20.4a4,4,0,0,0-4,4.16,4,4,0,0,0,1.34,2.91L73.52,57.84a12.78,12.78,0,0,1,1.14-1.3A14.37,14.37,0,0,1,76,55.39L45.6,21.74a4.06,4.06,0,0,0-2.91-1.34Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M125.66,118h-.28a10.38,10.38,0,0,1-7.51-3.46L84.73,77.82a3.21,3.21,0,0,1,1.47-5.23,6.74,6.74,0,0,0,4.52-4.52A3.21,3.21,0,0,1,96,66.61l36.72,33.13a10.48,10.48,0,0,1-7,18.26ZM92.26,76.59l30.37,33.65a4.06,4.06,0,0,0,5.89.15,4.06,4.06,0,0,0-.16-5.88L94.71,74.14a12.78,12.78,0,0,1-1.14,1.3A13,13,0,0,1,92.26,76.59Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M93.8,66.2a3.22,3.22,0,0,1-3.08-2.29,6.74,6.74,0,0,0-4.52-4.52,3.21,3.21,0,0,1-1.47-5.23l33.14-36.72A10.38,10.38,0,0,1,125.38,14a10.49,10.49,0,0,1,7.68,3.07,10.49,10.49,0,0,1-.39,15.19L96,65.37A3.22,3.22,0,0,1,93.8,66.2ZM92.26,55.39a14.37,14.37,0,0,1,1.31,1.15,12.78,12.78,0,0,1,1.14,1.3l33.65-30.37a4.06,4.06,0,0,0,.16-5.88,4.06,4.06,0,0,0-5.89.15Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M42.57,118a10.48,10.48,0,0,1-7-18.26L72.28,66.61a3.21,3.21,0,0,1,5.23,1.46A6.74,6.74,0,0,0,82,72.59a3.21,3.21,0,0,1,1.47,5.23L50.36,114.54A10.42,10.42,0,0,1,42.85,118ZM73.52,74.14,39.87,104.51a4.06,4.06,0,0,0,2.82,7.07,4.06,4.06,0,0,0,2.91-1.34L76,76.59a13,13,0,0,1-1.31-1.15A12.78,12.78,0,0,1,73.52,74.14Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M144.54,86.17a3.4,3.4,0,0,1-.94-.14,3.2,3.2,0,0,1-2.13-4,53.35,53.35,0,0,0-4-40.54,3.21,3.21,0,0,1,5.66-3,59.81,59.81,0,0,1,4.5,45.45A3.22,3.22,0,0,1,144.54,86.17Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M56.1,14.88a3.21,3.21,0,0,1-1.62-6,57.09,57.09,0,0,1,45.57-5.11,3.21,3.21,0,0,1-1.91,6.13,50.62,50.62,0,0,0-40.43,4.53A3.15,3.15,0,0,1,56.1,14.88Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M135.6,69.65a3.22,3.22,0,0,1-3.21-3.16,44,44,0,0,0-5-19.65,3.21,3.21,0,1,1,5.68-3,50.39,50.39,0,0,1,5.74,22.52,3.21,3.21,0,0,1-3.15,3.27Z",
    transform: "translate(-32.11 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8e5ec2b-a066-45b7-b351-71e7a03f98c3",
    d: "M65.82,25.13a3.21,3.21,0,0,1-1.5-6.05c8.23-4.32,17.2-4.69,23.23-4.59a3.21,3.21,0,0,1-.11,6.42c-8.57-.14-14.79,1.05-20.13,3.85A3.22,3.22,0,0,1,65.82,25.13Z",
    transform: "translate(-32.11 -1.2)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFanOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fan_on.bf11f310.svg";
export { ForwardRef as ReactComponent };